// The 7-day free trial is for a first subscription only; the API enforces it at checkout
// (any past subscription means paying from day one). Copy follows the same rule.
export const hasTrialAvailable = (me) => !me?.subscriptionStatus || me.subscriptionStatus === 'inactive';

// i18next context for trial copy: keys ending in _noTrial replace the trial offer once it's used
export const trialContext = (me) => (me && !hasTrialAvailable(me) ? 'noTrial' : undefined);

export const TRIAL_DAYS = 7;

// The Stripe prices (meu-treino-api .claude/rules/stripe-patterns.md): R$ 14,99 on meutreino.fit, US$ 5.99 on
// myworkoutskill.com. Checkout picks the price by the site's language, so the page shows the same one.
export const proPrice = (lang) => (lang === 'pt' ? 'R$ 14,99' : '$5.99');

/**
 * Where the account stands, from GET_ME. Pro is the API's rule (plan "pro" and active or trialing, the trial counts);
 * a failed renewal keeps plan "pro" while Stripe retries, but the account is locked like a free one until it's paid.
 * Canceling means Stripe ends the subscription (trial included) at the end of the period instead of renewing it.
 */
export const subscriptionState = (me) => {
  const status = me?.subscriptionStatus;
  const isPro = me?.plan === 'pro' && (status === 'active' || status === 'trialing');
  const isPastDue = me?.plan === 'pro' && status === 'past_due';
  return {
    isPro,
    isTrial: isPro && status === 'trialing',
    isCanceling: isPro && !!me?.cancelAtPeriodEnd,
    isPastDue,
    hasSubscription: isPro || isPastDue,
    trialAvailable: hasTrialAvailable(me),
  };
};

// 03/11/2026 or 11/3/2026, in the site's language
export const formatDay = (value, lang) =>
  value ? new Date(value).toLocaleDateString(lang === 'pt' ? 'pt-BR' : 'en-US') : null;

// When a trial started now ends (and the first charge happens)
export const trialEndFromNow = (now = Date.now()) => new Date(now + TRIAL_DAYS * 24 * 60 * 60 * 1000);
